import { defineComponent as _defineComponent } from 'vue'
import {
    encryptionInvite,
    encryptionInviteResult,
    encryptionInviteWithdraw,
    encryptionInviteWithdrawResult,
    encryptionUserInfo
} from "@/api/php/me";
import {
} from "@/api/php/user";
import { computed, ref, onMounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { Toast } from "vant";
import { cheackQuery, pickQueryParam, nativeToLogin, ToBack } from "@/uitls/native";
import { useI18n } from 'vue-i18n'
import { storeToRefs } from "pinia";
import { usePiniaState } from "@/store/userPinia";
import { addQueryParams } from "@/uitls/uitls";
import EventBus from "@/uitls/EventBus";
import { Storage } from "@/uitls/Storage";
import Platform from "@/config/platform";
import Clipboard from "clipboard";


export default /*#__PURE__*/_defineComponent({
  name: 'InviteAward',
  setup(__props, { expose }) {
  expose();

// 邀请赢话费奖励，印尼版
const piniaStore = usePiniaState();
const { user } = storeToRefs(piniaStore);
const { toLogin } = piniaStore;
const { t } = useI18n();
const router = useRouter();
const route = useRoute();
const desc_title_img = require(`@/assets/images/invite_award_desc_title.png`);
const wenhao_img = require(`@/assets/images/invite_award_wenhao.png`);
const close_img = require(`@/assets/images/guanbi_icon.png`);

const showSubmit = ref(false);
const showSubmit1 = ref(false);
const showRecord = ref(false);
const recordActive = ref(0);
const input_phone_err = ref(false);
const rule_html = ref("");

const CACHE_KEY = "activity_bg_picture";
// 获取缓存的图片地址
const cachedPicture = localStorage.getItem(CACHE_KEY);
const activity_bg_picture = ref(cachedPicture || "");
const activityBgStyle = computed(() => ({
    backgroundImage: activity_bg_picture.value ? `url(${activity_bg_picture.value})` : 'none'
}));

const myOs = ref("");
const originalUrl = location.href;

let share_to_url = ''; // 分享链接
let share_icon = ''; // 分享的图片
let share_text = ''; // 分享的文本
const invite_count = ref(0); // 邀请总人数
const score = ref(0); // 积分（可兑换）
const phone_num = ref(''); // 手机号, 兑换时提交
const invite_record = ref([
    // { regtime: 1721275670, nickname: 'Josin' },
]);
const order_list = ref([
    // { addtime: 1721275670, phone: '612345678912', status: 0 },
]);

const order_status_map = [t('me.submitted'), t('me.success'), t('me.failed')];
const showTopBar = ref(false);
let my_fid = ref('');

const showSheetView = ref(false);
const showExchangePointAlertView = ref(false);
const close_black = require("@/assets/images/close_black.png")
const huafei = require("@/assets/images/huafei_icon.png")
const caijin = require("@/assets/images/caijin.png")
const jifen = require("@/assets/images/jifen.png")

const rewardList = ref([]);

// https://www.jalatv16.cc/#/integralwallet/?os=android&token=5ca424e53efa0cc5cff48e6b778b7b3f&uid=36682093&fastkey=38c4fdc161034e5b1e451ccdc0a86185&customerId=64353&fid=610072759&channel=53&language=id


onMounted(async () => {
    cheackQuery(route);
    // let { os, fid, token, uid, fastkey, channel, customerId, type } = route.query;

    rewardList.value = [
        {
            title: t("兑换话费"),
            icon: huafei
        },
        {
            title: t("兑换彩金"),
            icon: caijin
        },
        {
            title: t("兑换积分"),
            icon: jifen
        },
    ];
    const os = pickQueryParam(route, 'os');
    const fid = pickQueryParam(route, 'fid');
    const token = pickQueryParam(route, 'token');
    const uid = pickQueryParam(route, 'uid');
    const fastkey = pickQueryParam(route, 'fastkey');
    const channel = pickQueryParam(route, 'channel');
    const customerId = pickQueryParam(route, 'customerId');

    myOs.value = os;
    if (os && os != "h5") {
        // my_fid.value = fid + '';
        if (fid == undefined || fid == '') {
            if (!await checkShowLogin()) {
                return;
            }
        } else {
            my_fid.value = fid + '';
            Storage.set('fid', fid);
            Storage.set('token', token);
            Storage.set('uid', uid);
            Storage.set('fastkey', fastkey);
            Storage.set('customerId', customerId);

            Platform.channel = Number(channel);

            console.log('channel', channel);

        }
        console.log('fid: ', fid);

    } else {
        showTopBar.value = true;
        await toLogin();
        my_fid.value = user.value.fid + '';


    }

    await getData();
    await getConfig();
});


const checkShowLogin = async () => {
    if (my_fid.value && my_fid.value != '') {
        return true;
    }
    const uid = Storage.get("uid");
    const fastkey = Storage.get("fastkey");
    const fid = Storage.get("fid");
    if (uid && uid != "" && fid && fid != "" && fastkey && fastkey != "") {
        // 已登录
        // await toLogin();
        my_fid.value = fid + '';

        await getConfig();
        await getData();
        return true;
    }

    EventBus.emit('showLogin', { refresh: true });
    return false;
}

const getConfig = async () => {
    const res: any = await encryptionInvite();
    
    console.log(res);

    if (res.code == 200) {

        
        share_to_url = addQueryParams(res.data.share_to_url + "/", { invite_code: my_fid.value });
        // share_to_url = addQueryParams('http://localhost:8000/' + "/#/", { invite_code: my_fid });
        share_icon = res.data.share_icon;
        // 邀请好友的文案，包含占位符{FID}, 需要前端替换占位符
        const replacements = { FID: my_fid.value };
        share_text = replacePlaceholders(res.data.share_text + ';', replacements);
        rule_html.value = res.data.rule_html;

        if (res.data.activity_bg_picture) {
            
            // 只有当图片地址变化时，才更新缓存
            const local_bg_picture = localStorage.getItem(CACHE_KEY);
            if (res.data.activity_bg_picture !== local_bg_picture) {
                localStorage.setItem(CACHE_KEY, res.data.activity_bg_picture);
                activity_bg_picture.value = res.data.activity_bg_picture;
            }
        }
        // history.replaceState(null, '', 'http://localhost:8123/share?tip="测试"');
        // alert("替换后台返回的分享地址成功");// 如果当前路由为 /share，则重定向到 /inviteaward
        // updateShareLink(share_to_url);
        // location.href = share_to_url;
    }
}

const getData = async () => {
    // 获取邀请记录
    const res: any = await encryptionInviteResult();
    if (res.code == 200 && res.data && res.data) {
        invite_record.value = res.data.list;
        invite_count.value = Number(res.data.total);
        score.value = Number(res.data.credit);
    }
    console.log(res);

    // 获取兑换记录
    const order_res: any = await encryptionInviteWithdrawResult();
    if (order_res.code == 200 && order_res.data) {
        order_list.value = order_res.data;
    }
    console.log(order_res)

    // encryptionUserInfo
    if (!user.value.avatar || user.value.avatar == "") {
        const info: any = await encryptionUserInfo();
        console.log('user info', info);
        if (info.code == 200 && info.data) {
            user.value.avatar = info.data.headurl;
        }
    }

}

const showRecordDialog = async () => {
    if (!await checkShowLogin()) {
        return;
    }
    showRecord.value = true;
}

//兑换的统一入口
const showAllExchangeSheet = async () => {
    showSheetView.value = true;
}

const showSubmitDialog = async (index) => {
    if (!await checkShowLogin()) {
        return;
    }
    if (index == 0) {
        showSubmit.value = true;
    } else if (index == 1) {
        showSubmit1.value = true;
    } else if (index == 2) {
        showExchangePointAlertView.value = true;
    }

}

const beforeSubmitClose = async (action) => {
    if (action === 'confirm') {
        if (phone_num.value == '') {
            Toast({ message: t('me.oninutphone'), position: 'top' });
            return false;
        } else {
            let ret: any = await encryptionInviteWithdraw({
                phone: phone_num.value,
                type: 1
            });
            if (ret.code == 200) {
                Toast({ message: t('me.integralSuccess'), type: 'success' });
                getData();
                return true;
            } else {
                // console.log(ret);
                const msg = ret.msg || t('me.withdrawFailed');
                Toast({ message: msg, type: 'fail' });
                return false;
            }
        }
    } else {
        return true;
    }
};

const beforeSubmitClose1 = async (action) => {
    if (action === 'confirm') {
        let ret: any = await encryptionInviteWithdraw({
            type: 2
        });
        if (ret.code == 200) {
            Toast({ message: t('me.integralSuccess'), type: 'success' });
            getData();
            return true;
        } else {
            // console.log(ret);
            const msg = ret.msg || t('me.withdrawFailed');
            Toast({ message: msg, type: 'fail' });
            return false;
        }
    } else {
        return true;
    }
};

const beforeSubmitClose2 = async (action) => {
    if (action === 'confirm') {
        let ret: any = await encryptionInviteWithdraw({
            type: 3
        });
        
        if (ret.code == 200) {
            Toast({ message: t('me.integralSuccess'), type: 'success' });
            getData();
            return true;
        } else {
            // console.log(ret);
            const msg = ret.msg || t('me.withdrawFailed');
            Toast({ message: msg, type: 'fail' });
            return false;
        }
    } else {
        return true;
    }
};

const closeSheetAction = () => {
    showSheetView.value = false;
}

function replacePlaceholders(template, replacements) {
    return template.replace(/{(.*?)}/g, (match, p1) => replacements[p1] || '');
}

function formatDate(timestamp) {
    // 创建一个新的 Date 对象，传入时间戳（单位为毫秒）
    const date = new Date(Number(timestamp) * 1000);

    // 获取年、月、日信息
    const year = date.getFullYear();
    // 注意月份从0开始，所以要加1
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    const hour = ('0' + date.getHours()).slice(-2);
    const min = ('0' + date.getMinutes()).slice(-2);


    // 返回格式化后的日期字符串，使用 dd/MM/yy 格式
    return `${day}/${month} ${hour}:${min}`;
}


const onCopyClick = (copyclass: string, data: string) => {
    // copyclass元素的类名，data要复制的内容
    let clipboard = new Clipboard("." + copyclass, {
        text: () => {
            return data;
        },
    });
    clipboard.on("success", (e) => {
        Toast.success(t('me.fzljcg'));
        clipboard.destroy();
    });
    clipboard.on("error", (e) => {
        console.log("浏览器不支持复制");
        // 释放内存
        clipboard.destroy();
    });
};

const onShareClick = async () => {
    if (!await checkShowLogin()) {
        return;
    }
    // 发送到whatsapp
    function sendWhatsAppMessage() {
        // 替换成你想要发送的消息内容
        var message = share_text + "  " + share_to_url;
        // 构造 WhatsApp 链接
        var url = "https://wa.me/?text=" + encodeURIComponent(message);
        // 打开 WhatsApp
        window.open(url);
    }

    if (navigator.share) {
        const imageUrl = share_icon;
        const text = share_text;
        const shareUrl = share_to_url;
        let shareData: ShareData = {
            title: 'Title of the shared content',
            text: text,
            url: shareUrl,
        };
        // 

        // 使用 async/await 来简化异步代码
        async function shareContent() {
            try {
                // 获取图片并转换为 Blob 对象
                const response = await fetch(imageUrl);
                const imageBlob = await response.blob();

                // 创建分享内容对象
                const filesArray = [new File([imageBlob], 'share.jpg', { type: imageBlob.type })]; // 将 Blob 对象转换为 File 对象
                shareData.files = filesArray;
                if (navigator.canShare(shareData)) {
                    // 调用 navigator.share 进行分享
                    await navigator.share(shareData);
                    console.log('Successful share');
                } else {
                    sendWhatsAppMessage();
                }

            } catch (error) {
                // 图片加载失败，分享文字+链接
                shareData.files = undefined;
                await navigator.share(shareData);
            }
        }

        shareContent();
    } else {
        sendWhatsAppMessage();
    }

};



const __returned__ = { piniaStore, user, toLogin, t, router, route, desc_title_img, wenhao_img, close_img, showSubmit, showSubmit1, showRecord, recordActive, input_phone_err, rule_html, CACHE_KEY, cachedPicture, activity_bg_picture, activityBgStyle, myOs, originalUrl, share_to_url, share_icon, share_text, invite_count, score, phone_num, invite_record, order_list, order_status_map, showTopBar, my_fid, showSheetView, showExchangePointAlertView, close_black, huafei, caijin, jifen, rewardList, checkShowLogin, getConfig, getData, showRecordDialog, showAllExchangeSheet, showSubmitDialog, beforeSubmitClose, beforeSubmitClose1, beforeSubmitClose2, closeSheetAction, replacePlaceholders, formatDate, onCopyClick, onShareClick, ToBack }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})